// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invite-member-modal {
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.85);
  z-index: 9999;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
}
.invite-member-modal .modal-container {
  font-family: "Proxima Nova", sans-serif;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(129, 159, 188, 0.15);
  border-radius: 25px;
  width: 600px;
  padding: 30px;
}
.invite-member-modal .modal-container .modal-title {
  display: flex;
  justify-content: center;
  font-weight: 700;
  font-size: 24px;
  color: var(--secondary-color-1);
  position: relative;
  justify-content: space-between;
}
.invite-member-modal .modal-container .modal-title .close {
  cursor: pointer;
}
.invite-member-modal .modal-container .modal-title .close:hover {
  opacity: 0.75;
}
.invite-member-modal .modal-container .content {
  display: flex;
  flex-direction: column;
  font-family: "Proxima Nova", sans-serif;
}
.invite-member-modal .modal-container .content > p {
  margin: 0;
}
.invite-member-modal .modal-container .content .price-value {
  font-weight: 500;
  font-size: 18px;
  color: #6C767C;
}
.invite-member-modal .modal-container .content .new-user-form {
  animation: fadeIn 0.5s;
  visibility: visible;
}
.invite-member-modal .modal-container .content > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.invite-member-modal .modal-container .content > div .name {
  display: flex;
  width: 100%;
}
.invite-member-modal .modal-container .content > div .form-input {
  width: 100%;
}
.invite-member-modal .modal-container .content > div .form-input input[type=number] {
  -moz-appearance: textfield;
}
.invite-member-modal .modal-container .content > div .form-input input[type=number]::-webkit-inner-spin-button,
.invite-member-modal .modal-container .content > div .form-input input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.invite-member-modal .modal-container .content > div .form-input > label {
  font-size: 14px;
  font-weight: 600;
  color: var(--secondary-color-5);
  display: flex;
  align-items: center;
}
.invite-member-modal .modal-container .content > div .form-input > label span.tooltip {
  position: relative;
  cursor: pointer;
}
.invite-member-modal .modal-container .content > div .form-input > label span.tooltip:before {
  content: attr(data-text);
  position: absolute;
  top: -50px;
  left: 10px;
  margin-left: 15px;
  width: 200px;
  padding: 10px;
  border-radius: 10px;
  background: var(--secondary-color-1);
  color: #fff;
  text-align: center;
  font-size: 12px;
  display: none;
}
.invite-member-modal .modal-container .content > div .form-input > label span.tooltip:hover:before {
  display: block;
}
.invite-member-modal .modal-container .content > div .form-input > input {
  font-family: "Proxima Nova", sans-serif;
  margin-top: 10px;
}
.invite-member-modal .modal-container .content > div .form-input > input::placeholder {
  font-family: "Proxima Nova", sans-serif;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/TeamDetails/modules/InviteMemberModal/inviteMemberModal.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,2CAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AAAI;EACI,uCAAA;EACA,mBAAA;EACA,kDAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AAER;AADQ;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;EACA,8BAAA;AAGZ;AAFY;EACI,eAAA;AAIhB;AAHgB;EACI,aAAA;AAKpB;AADQ;EACI,aAAA;EACA,sBAAA;EACA,uCAAA;AAGZ;AAFY;EAAM,SAAA;AAKlB;AAJY;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAMhB;AAJY;EACI,sBAAA;EACA,mBAAA;AAMhB;AAJY;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;AAMhB;AALgB;EACI,aAAA;EACA,WAAA;AAOpB;AALgB;EACI,WAAA;AAOpB;AANoB;EACI,0BAAA;AAQxB;AANoB;;EAEI,wBAAA;EACA,SAAA;AAQxB;AANoB;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;AAQxB;AAPwB;EACI,kBAAA;EACA,eAAA;AAS5B;AAR4B;EACI,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AAUhC;AAR4B;EACI,cAAA;AAUhC;AANoB;EACI,uCAAA;EACA,gBAAA;AAQxB;AAPwB;EACI,uCAAA;AAS5B;AAFI;EACI;IAAK,UAAA;EAKX;EAJM;IAAO,UAAA;EAOb;AACF","sourcesContent":[".invite-member-modal {\n    width: 100%;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    background-color: rgba($color: white, $alpha: .85);\n    z-index: 9999;\n    position: fixed;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    .modal-container {\n        font-family: 'Proxima Nova', sans-serif;\n        background: #FFFFFF;\n        box-shadow: 0px 4px 20px rgba(129, 159, 188, 0.15);\n        border-radius: 25px;\n        width: 600px;\n        padding: 30px;\n        .modal-title {\n            display: flex;\n            justify-content: center;\n            font-weight: 700;\n            font-size: 24px;\n            color: var(--secondary-color-1);\n            position: relative;\n            justify-content: space-between;\n            .close {\n                cursor: pointer;\n                &:hover {\n                    opacity: .75;\n                }\n            }\n        }\n        .content {\n            display: flex;\n            flex-direction: column;\n            font-family: 'Proxima Nova', sans-serif;\n            > p { margin: 0; }\n            .price-value {\n                font-weight: 500;\n                font-size: 18px;\n                color: #6C767C;\n            }\n            .new-user-form {\n                animation: fadeIn .5s;\n                visibility: visible;\n            }\n            > div {\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                flex-direction: column;\n                .name {\n                    display: flex;\n                    width: 100%;\n                }\n                .form-input {\n                    width: 100%;\n                    input[type=\"number\"] {\n                        -moz-appearance: textfield;\n                    }\n                    input[type=\"number\"]::-webkit-inner-spin-button, \n                    input[type=\"number\"]::-webkit-outer-spin-button { \n                        -webkit-appearance: none; \n                        margin: 0; \n                    }\n                    > label {\n                        font-size: 14px;\n                        font-weight: 600;\n                        color: var(--secondary-color-5);\n                        display: flex;\n                        align-items: center;\n                        span.tooltip {\n                            position: relative;\n                            cursor: pointer;\n                            &:before {\n                                content: attr(data-text);\n                                position:absolute;\n                                top: -50px;\n                                left: 10px;\n                                margin-left: 15px;\n                                width: 200px;\n                                padding: 10px;\n                                border-radius: 10px;\n                                background:var(--secondary-color-1);\n                                color: #fff;\n                                text-align:center;\n                                font-size: 12px;\n                                display: none;\n                            }\n                            &:hover:before {\n                                display:block;\n                            }\n                        }\n                    }\n                    > input {\n                        font-family: 'Proxima Nova', sans-serif;\n                        margin-top: 10px;\n                        &::placeholder {\n                            font-family: 'Proxima Nova', sans-serif;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    @keyframes fadeIn {\n        0% { opacity: 0; }\n        100% { opacity: 1; }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
